function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-317.321 -30.323)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 38.624,
  cy: 38.624,
  r: 38.624,
  transform: "translate(318.071 31.073)",
  fill: "none",
  stroke: "#ed1844",
  strokeLinecap: "square",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(351.18 47.632)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M338.41,79.957a5.517,5.517,0,1,1,5.548,5.417A5.434,5.434,0,0,1,338.41,79.957Zm2.4-38.712h6.3a1.836,1.836,0,0,1,1.833,1.942l-1.454,25.642a1.277,1.277,0,0,1-1.275,1.2h-4.569a1.278,1.278,0,0,1-1.276-1.208l-1.4-25.644A1.838,1.838,0,0,1,340.806,41.245Z",
  transform: "translate(-338.41 -41.245)",
  fill: "none",
  stroke: "#ed1844",
  strokeLinecap: "square",
  strokeWidth: 1.5
})));
var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.af738d5e.svg";
export { ForwardRef as ReactComponent };